import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { Router, NavigationEnd } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class NavigationService implements OnDestroy {
  private currentPageSubject = new BehaviorSubject<string>("Chatbots");
  public currentPage$: Observable<string> =
    this.currentPageSubject.asObservable();
  private routeSubscription: Subscription;

  constructor(private router: Router) {
    // Update current page based on route changes
    this.routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects || event.url;
        const segments = url.split("/").filter((segment) => segment);
        const currentRoute = segments[0] || "chatbots";
        this.currentPageSubject.next(this.formatPageName(currentRoute));
      }
    });
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  private formatPageName(route: string): string {
    // Convert route to a display-friendly format
    return route
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  navigateTo(page: string): void {
    this.router.navigate([page]);
    this.currentPageSubject.next(this.formatPageName(page));
  }

  getCurrentPage(): string {
    return this.currentPageSubject.value;
  }
}
